import { render, staticRenderFns } from "./QuestionInputItem.vue?vue&type=template&id=b885eb34&scoped=true&lang=pug"
import script from "./QuestionInputItem.vue?vue&type=script&lang=ts"
export * from "./QuestionInputItem.vue?vue&type=script&lang=ts"
import style0 from "./QuestionInputItem.vue?vue&type=style&index=0&id=b885eb34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b885eb34",
  null
  
)

export default component.exports